<template>
  <div :class="classes" @click="onclick">
    <input tabindex="-1" type="checkbox" class="ms-CheckBox-input" :checked="value" :disabled="disabled" />
    <label role="checkbox" class="ms-CheckBox-field" :class="{ 'is-disabled': disabled, 'is-checked': value }" tabindex="0" :aria-checked="value">
      <span class="ms-Label">{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'primary', 'secondary'].indexOf(value) !== -1;
      }
    },
    size: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'small'].indexOf(value) !== -1;
      }
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      const classes = ['ms-CheckBox'];
      if (this.color === 'primary') {
        classes.push('ms-CheckBox--primary');
      }
      if (this.size === 'small') {
        classes.push('ms-CheckBox--small');
      }
      if (this.disabled) {
        classes.push('is-disabled');
      }
      return classes;
    }
  },

  mounted() {
    new fabric['CheckBox'](this.$el, function() {});
  },
  methods: {
    onclick() {
      this.$emit('change', !this.value);
      this.$emit('input', !this.value);
    }
  }
};
</script>
